import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import EntityFilterProvider from '../entity-filter-provider/entity-filter-provider.vue';
const AutoFormGroup = () =>
  import('@shared/components/forms/auto-form/auto-form-group/auto-form-group.vue');

@Component({
  name: 'bpc-std-filter',
  components: {
    'bpc-auto-form-group': AutoFormGroup,
    'bpc-entity-filter-provider': EntityFilterProvider,
  },
})
export default class StdFilter extends Vue {
  $refs!: {
    filterProvider: InstanceType<typeof EntityFilterProvider> & {
      saveEntity(formModel: AnyEntity): void;
    };
    autoFormGroup: InstanceType<any> & {};
  };

  @Prop(String) readonly entity: string;
  @Prop({ type: String, default: 'default' }) readonly filterConfigName: string;
  @Prop(Object) readonly value: AnyEntity;
  @Prop({ type: String, default: 'filter' }) readonly filterType: string;
  @Prop({ type: String, default: 'table' }) readonly storeName: string;
  @Prop(String) readonly configFileName: string;

  public filterExcluded = [
    'sortedBy',
    'orderBy',
    'page',
    'per_page',
    'tenantAlias',
    'search',
    'orderDirection',
  ];

  get filterModel() {
    return this.$store.getters[`${this.storeName}/filterModel`](this.entity) || {};
  }

  set filterModel(model) {
    this.$store.commit(`${this.storeName}/setFilterModel`, {
      entity: this.entity,
      model: model,
    });
  }

  @Watch('filterModel', { immediate: true, deep: true })
  onFilterModelChange() {
    this.$emit('on-change-filter', this.filterModel);
  }
}
